import {
  Component, EventEmitter, Inject, Output,

} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DataConnection } from '@nimmsta/ng-commons-lib';
import { DataConnectionService } from '@nimmsta/ng-workflow-lib';
import dayjs from 'dayjs';
import { JobDashboardConfiguration, JobDashboardRange } from './job-dashboard-configuration';

@Component({
  selector: 'app-job-dashboard-form',
  templateUrl: './job-dashboard-form.component.html',
})
export class JobDashboardFormComponent {
  form: FormGroup;

  @Output() dataChange = new EventEmitter<JobDashboardConfiguration>();

  dataConnections: DataConnection[] = [];

  customRange = JobDashboardRange.CUSTOM;

  rangeOptions = Object.entries(JobDashboardRange).map(([key, value]) => ({
    key,
    value: value as JobDashboardRange,
  }));

  dateRange: Date[] = [];

  constructor(
    @Inject('formData') public data: JobDashboardConfiguration,
    private fb: FormBuilder,
    private dataConnectionService: DataConnectionService,
  ) {
    this.dataConnectionService.simpleList()
      .subscribe((connections: DataConnection[]) => {
        connections.sort((a, b) => a.name.localeCompare(b.name));
        this.dataConnections = connections;
      });

    this.form = this.fb.group({
      dataConnectionIds: [data.dataConnectionIds || []],
      title: [data.title || ''],
      description: [data.description || ''],
      range: [data.range || JobDashboardRange.THIS_WEEK],
      from: [data.from || null],
      to: [data.to || null],
    });

    if (data.from && data.to) {
      this.dateRange = [dayjs(data.from).toDate(), dayjs(data.to).toDate()];
    }

    this.form.valueChanges.subscribe((value) => {
      this.dataChange.emit(value);
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customRangeChange(event: any) {
    this.form.patchValue({
      range: this.customRange,
      from: event[0] ? dayjs(event[0]) : null,
      to: event[1] ? dayjs(event[1]) : null,
    });
  }
}
